import type React from "react";
import { useState } from "react";

interface FAQItemProps {
	question: string;
	answer: string;
}

const FAQItem: React.FC<FAQItemProps> = ({ question, answer }) => {
	const [isOpen, setIsOpen] = useState(false);

	return (
		<div className="border-b border-gray-200 pb-4">
			<button
				type="button"
				className="flex justify-between items-center w-full text-left"
				onClick={() => setIsOpen(!isOpen)}
			>
				<span className="text-lg font-semibold">{question}</span>
				<span className="text-2xl">{isOpen ? "−" : "+"}</span>
			</button>
			{isOpen && <p className="mt-2 text-gray-600">{answer}</p>}
		</div>
	);
};

export default FAQItem;
